import { useState } from 'react'
import {
  apiErrorMessage,
  useAdminAuditExport,
  useAdminAuditLog,
  type AuditFilterParams,
} from '../lib/api'
import { fmtDateTime } from '../lib/format'

export function AuditLogPage() {
  const [params, setParams] = useState<AuditFilterParams>({ page: 1, perPage: 50 })
  const q = useAdminAuditLog(params)
  const exportMut = useAdminAuditExport()

  const onExport = () => {
    exportMut.mutate(params, {
      onSuccess: (url) => {
        const a = document.createElement('a')
        a.href = url
        a.download = `audit-${new Date().toISOString().slice(0, 10)}.csv`
        document.body.appendChild(a)
        a.click()
        a.remove()
        setTimeout(() => URL.revokeObjectURL(url), 60_000)
      },
    })
  }

  return (
    <>
      <header className="page-header">
        <div className="page-header__title-row">
          <h1 className="page-header__title">Audit log</h1>
          <span className="page-header__subtitle">Tamper-evident record of admin activity.</span>
        </div>
        <div className="page-header__actions">
          <button type="button" className="btn btn--primary btn--sm" onClick={onExport} disabled={exportMut.isPending}>
            {exportMut.isPending ? 'Exporting…' : 'Export CSV'}
          </button>
        </div>
      </header>

      {exportMut.isError && (
        <div className="auth-card__error" role="alert" style={{ display: 'flex', marginBottom: 'var(--space-3)' }}>
          {apiErrorMessage(exportMut.error)}
        </div>
      )}

      <div className="filter-bar" style={{ marginBottom: 'var(--space-4)' }}>
        <div className="filter-bar__group">
          <label className="field__label" htmlFor="audit-action">Action</label>
          <input id="audit-action" type="text" className="field__input" style={{ width: 200 }}
            value={params.action ?? ''}
            onChange={(e) => setParams((p) => ({ ...p, action: e.target.value || undefined }))} />
        </div>
        <div className="filter-bar__group">
          <label className="field__label" htmlFor="audit-ttype">Target type</label>
          <input id="audit-ttype" type="text" className="field__input" style={{ width: 200 }}
            value={params.targetType ?? ''}
            onChange={(e) => setParams((p) => ({ ...p, targetType: e.target.value || undefined }))} />
        </div>
        <div className="filter-bar__group">
          <label className="field__label" htmlFor="audit-tid">Target ID</label>
          <input id="audit-tid" type="text" className="field__input" style={{ width: 280 }}
            value={params.targetId ?? ''}
            onChange={(e) => setParams((p) => ({ ...p, targetId: e.target.value || undefined }))} />
        </div>
      </div>

      <div className="admin-table">
        <table>
          <thead>
            <tr>
              <th style={{ width: 180 }}>Timestamp</th>
              <th>Actor</th>
              <th>Action</th>
              <th>Target</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {q.isLoading && (
              <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--text-tertiary)' }}>Loading…</td></tr>
            )}
            {q.data && q.data.entries.length === 0 && (
              <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--text-tertiary)' }}>No entries.</td></tr>
            )}
            {q.data && q.data.entries.map((e) => (
              <tr key={e.id}>
                <td style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--text-xs)', color: 'var(--text-secondary)', whiteSpace: 'nowrap' }}>{fmtDateTime(e.createdAt)}</td>
                <td style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--text-xs)' }}>{e.actorId ?? '—'}</td>
                <td><code style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--text-xs)' }}>{e.action}</code></td>
                <td style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--text-xs)' }}>{e.targetType}/{e.targetId.slice(0, 8)}…</td>
                <td style={{ maxWidth: 420, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontFamily: 'var(--font-mono)', fontSize: 'var(--text-xs)', color: 'var(--text-secondary)' }}>
                  {JSON.stringify(e.details)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
}
